module.exports = __webpack_public_path__ + "img/Skill.c1a0f28b.svg";